import React, { useEffect, useState } from 'react'
import { Icon, IconButton, Table } from 'rsuite'
import EditButton from '../../components/buttons/editButton/EditButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function MAndEFManageCBTeamTable({
  dataList,
  onEdit = () => {},
  onDelete = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [data, setData] = useState(dataList || [])

  useEffect(() => {
    if (dataList) {
      setData(dataList)
    }
  }, [dataList])

  return (
    <>
      <Table autoHeight rowHeight={65} data={data} wordWrap>
        <Column width={80} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>
        <Column width={200}>
          <HeaderCell>ชื่อ-สกุล</HeaderCell>
          <Cell>
            {(rowData) => {
              return rowData.preName + ' ' + rowData.firstName + ' ' + rowData.lastName
            }}
          </Cell>
        </Column>
        <Column width={200}>
          <HeaderCell>ตำแหน่ง</HeaderCell>
          <Cell dataKey="position" />
        </Column>

        <Column width={150}>
          <HeaderCell>เบอร์ติดต่อ</HeaderCell>
          <Cell dataKey="mobileNumber" />
        </Column>

        <Column width={200}>
          <HeaderCell>อีเมล</HeaderCell>
          <Cell dataKey="email" />
        </Column>

        <Column minWidth={200} flexGrow={1}>
          <HeaderCell>องค์กรต้นสังกัด</HeaderCell>
          <Cell dataKey="organization" />
        </Column>

        <Column width={220} align="center" fixed="right">
          <HeaderCell>จัดการ</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <EditButton
                    children="แก้ไข"
                    onClick={() => {
                      onEdit(rowData.id)
                    }}
                    style={{
                      marginRight: 5,
                      marginBottom: 0,
                    }}
                  />
                  <CancelButton
                    children="ลบ"
                    onClick={() => {
                      onDelete(rowData.id)
                    }}
                    style={{
                      marginRight: 5,
                      marginBottom: 0,
                    }}
                    icon="trash-o" 
                  />
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </>
  )
}
